export default "__VITE_ASSET__CD_BH0ql__"